import { fetchHelper } from "../utils"

export const getActiveUsers = async () => {
    return fetchHelper({
        url: 'users/actives',
        method: 'GET',
    }) as Promise<any[]>
}

export const getUsers = async () => {
    return fetchHelper({
        url: 'users',
        method: 'GET',
    }) as Promise<any[]>
}